import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { notificationService } from "../../services";
import { NOTIFICATIONS_CLEARED_EVENT } from "../../services/notificationService";

const SmsNotif = () => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const token = typeof window !== "undefined" ? localStorage.getItem("authToken") : null;
    if (!token) return undefined;

    let active = true;
    const refresh = async () => {
      try {
        const count = await notificationService.getUnreadCount();
        if (active) setUnreadCount(count || 0);
      } catch {
        /* silencieux */
      }
    };

    refresh();
    const interval = setInterval(refresh, 60000);

    const onCleared = () => {
      if (active) setUnreadCount(0);
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };

    window.addEventListener(NOTIFICATIONS_CLEARED_EVENT, onCleared);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      active = false;
      clearInterval(interval);
      window.removeEventListener(NOTIFICATIONS_CLEARED_EVENT, onCleared);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return (
    <Link to="/messages" className="p-3 relative" aria-label="Notifications">
      {unreadCount > 0 && (
        <span className="absolute bg-red-600 text-white px-2 rounded-full right-0 top-0 text-[12px]">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
      <i className="fi fi-rr-comment-dots text-xl" />
    </Link>
  );
};

export default SmsNotif;
